"use client";

import React, { useState } from 'react';
import styles from './AdminBurger.module.scss';
import Link from 'next/link';
import { FaChevronUp, FaChevronDown, FaArrowLeft } from 'react-icons/fa6';
import { Group } from '@mantine/core';

interface SubLink {
  label: string;
  link: string;
}

interface Section {
  label: string;
  links: SubLink[];
}

interface DrawerProps {
  data: {
    sections: Section[];
  };
}

const AdminBurger: React.FC<DrawerProps> = ({ data }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeSection, setActiveSection] = useState<null | number>(null);

  const toggleDrawer = () => setIsOpen(prev => !prev);
  const goBack = () => setActiveSection(null);

  return (
    <div className={`${styles.drawerWrapper} ${isOpen ? styles.open : styles.closed}`}>
      <button className={styles.toggleButton} onClick={toggleDrawer}>
        {isOpen ? <FaChevronDown /> : <FaChevronUp />}
      </button>

      <div className={styles.drawerContent}>
        {activeSection === null ? (
          <div className={styles.sectionGrid}>
            {data.sections.map((section, index) => (
              <button
                key={index}
                className={styles.sectionBox}
                onClick={() => setActiveSection(index)}
              >
                {section.label}
              </button>
            ))}
          </div>
        ) : (
          <div className={styles.subsectionGrid}>
            <Group justify='space-around' style={{ width: '100%' }}>
              <button className={styles.backButton} onClick={goBack}>
                <FaArrowLeft /> Retour
              </button>
              <Group gap='xl'>
                {data.sections[activeSection].links.map((sub, idx) => (
                  <Link key={idx} href={sub.link} className={styles.subsectionBox}>
                    {sub.label}
                  </Link>
                ))}
              </Group>
            </Group>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminBurger;
